import React, { useEffect } from 'react';
import { SelectableGrid } from 'src/components/Shared/SelectableGrid';
import { ExchangeTransactionFrequency } from 'src/redux/modules/exchangeTransaction';
import { START_DATE_TOOL_TIP } from 'src/redux/modules/modals/modals.module';
import { selectableDays, selectableMonths } from 'src/settings/settings';
import styles from './styles.module.scss';

export interface AutoExchangeFrequencyProps
  extends ExchangeTransactionFrequency {
  customerWebViewEnabled: boolean;
  isSalesforceRep: boolean;
  fromFundName: string;
  grossValueString: string;
  grossUnit: string;
  openModal(modalName: string): void;
  selectDay: CallableFunction;
  selectMonth: CallableFunction;
  toFundName: string;
}

const AutoExchangeFrequency: React.FC<AutoExchangeFrequencyProps> = ({
  customerWebViewEnabled,
  isSalesforceRep,
  fromFundName,
  toFundName,
  openModal,
  selectedDays,
  selectedMonths,
  selectDay,
  selectMonth,
  grossValueString,
  grossUnit,
}) => {
  // rerender if selectedDays, selectedMonths changes

  useEffect(() => {}, [selectedDays, selectedMonths]);
  return (
    <div className={styles['auto-exchange-frequency-container']}>
      {grossUnit !== 'PERCENT' && (
        <p
          className={`e2e-frequency-instructions ${styles['frequency-instructions']}`}
        >
          Determine how often you will exchange{' '}
          <span className={styles['bolded']}>{grossValueString}</span> from{' '}
          <span className={styles['bolded']}>{fromFundName}</span> to{' '}
          <span className={styles['bolded']}>{toFundName}.</span>
        </p>
      )}
      <div className={styles['frequency-container']}>
        <SelectableGrid
          showSelectAllOption
          allItems={selectableMonths}
          buttonProps={{
            btnSize: 64,
            phoneColNum: 3,
            idPrefix(id) {
              return `monthButton_${id}`;
            },
          }}
          handleSelect={(...args) => {
            selectMonth(...args);
          }}
          id="month-chart"
          optionName="Months"
          selectedItems={selectedMonths}
          title="Months"
        />
        <SelectableGrid
          allItems={selectableDays}
          buttonProps={{
            btnSize: 40,
            phoneColNum: 5,
            idPrefix(id) {
              return `dayButton_${id}`;
            },
          }}
          handleSelect={(...args) => {
            selectDay(...args);
          }}
          id="day-chart"
          limitText="Max 4 days per month"
          maxSelectCount={4}
          selectedItems={selectedDays}
          showSelectAllOption={false}
          title="Dates"
        >
          <div className={styles['disclaimer-txt']}>
            {!customerWebViewEnabled && isSalesforceRep ? (
              <span>
                <p>
                  By selecting this service, you acknowledge that automatic
                  transactions will be placed in accordance with the following:
                </p>
                <br />
                <p>
                  Automatic Transactions programs are typically established the
                  following business day, but can take up to three business days
                  to be completed.
                </p>
                <br />
                <p>
                  Except for certain dates as noted below, if one of your chosen
                  dates occurs on a weekend or holiday, the trade will be placed
                  on the next business day at that business day’s Net Asset
                  Value (NAV).
                </p>
                <br />
                <p>
                  <b>Exception:</b> If your chosen date falls either on a day
                  that does not exist on the calendar (ex. February 31st) or on
                  the last weekend of the year and the next business day is the
                  following year, your trade will be placed on the previous
                  business day at that business day’s NAV.
                </p>
              </span>
            ) : (
              <span>
                <a
                  className={styles['link']}
                  onClick={() => {
                    openModal(START_DATE_TOOL_TIP);
                  }}
                >
                  View important details
                </a>{' '}
                about start dates, including weekdays and holidays.
              </span>
            )}
          </div>
        </SelectableGrid>
      </div>
    </div>
  );
};

export default AutoExchangeFrequency;
